import { CALL_API } from '../middleware/api';
import sc5Api from '../api/SC5Api';
// import { SC5Report } from '../types/SC5Report';
import { BGEReport } from '../types/BGEReport';


export const GET_REPORT_REQUEST = 'GET_REPORT_REQUEST';
export const GET_REPORT_SUCCESS = 'GET_REPORT_SUCCESS';
export const GET_REPORT_FAILURE = 'GET_REPORT_FAILURE';

export const getReport = (options: any, callback = (): void => {}, errorCallback = (): void => {}): any => (
  dispatch: (options: object) => void,
): any => (
  dispatch({
    [CALL_API]: {
      types: [
        GET_REPORT_REQUEST,
        GET_REPORT_SUCCESS,
        GET_REPORT_FAILURE,
      ],
      request: (): Promise<BGEReport> => sc5Api.getReport(),
      callback,
      errorCallback,
    },
  })
);
